var path = 'scripts/views/components/line-item-icon.html';
var html = "<a class=\"line-item-details\"\n      ng-click=\"$ctrl.openFullLineItem()\"\n      ng-show=\"$ctrl.transaction.lineItemDetails.hasLineItems\"\n      uib-tooltip=\"{{ 'transactions.ViewLineItem' | translate }}\"\n      tooltip-class=\"tooltip-bring-to-front\"\n      tooltip-append-to-body=\"true\">\n    <span class=\"line-item-details-icon fa fa-list-ol\"></span>\n    <span ng-if=\"$ctrl.showText\" class=\"uppercase line-item-text\" translate>transactions.ViewLineItem</span>\n</a>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/components/line-item-icon.html
// module id = 319
// module chunks = 0